import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Badge from '../../../Badge/Badge'

const getInspectionRatingBadgeColor = (rating) => {
  if (rating === 'Good') return 'green-filled'
  if (rating === 'Fair') return 'orange-filled'
  if (rating === 'Poor') return 'red-filled'
  return 'gray'
}

const GuidedInspectionItem = ({ item }) => {
  const { t } = useTranslation(['internal-inspections'])
  return (
    <React.Fragment>
      {item.rating ? (
        <div>
          <span className="details-label">{t('internal-inspections:locationItem.condition')}</span>
          <Badge color={getInspectionRatingBadgeColor(item.rating)}>{item.rating}</Badge>
        </div>
      ) : null}
      {item.questions && item.questions.length ? (
        <div>
          <span className="details-label">{t('internal-inspections:locationItem.questions')}</span>
          {item.questions.map((question) => (
            <div className="question" key={question.id}>
              <span className="details-desc">{question.question}</span>
              {question.answer ? (
                <Badge color="green">{t('internal-inspections:locationItem.yes')}</Badge>
              ) : (
                <Badge color="red">{t('internal-inspections:locationItem.no')}</Badge>
              )}
            </div>
          ))}
        </div>
      ) : null}
    </React.Fragment>
  )
}

GuidedInspectionItem.propTypes = {
  item: PropTypes.object,
}

export default GuidedInspectionItem
